"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stream_1 = require("../utils/stream");
const ai = (sdk) => {
    const { sdkConfig: { url }, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        generateLernsetWorksheet: async (payload) => {
            const endpoint = `${url}/v4/ai/generateLernsetWorksheet`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        streamAiConversationResponse: async (payload, abortSignal) => {
            const endpoint = `${url}/v4/ai/conversation`;
            const stream = await httpClient.stream(endpoint, { payload, abortSignal });
            const processedStream = (0, stream_1.processStream)(stream);
            return processedStream;
        },
        generateSuggestions: async (payload) => {
            const endpoint = `${url}/v4/ai/suggestions`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        uploadAttachment: async (formData, abortSignal) => {
            const endpoint = `${url}/v4/ai/attachments`;
            const result = await httpClient.post(endpoint, {
                payload: formData,
                abortSignal,
            });
            return result.data;
        },
        getAttachment: async (attachmentHashName) => {
            const endpoint = `${url}/v4/ai/attachments/${attachmentHashName}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getAttachmentsRemainingLimit: async () => {
            const endpoint = `${url}/v4/ai/attachments/remainingLimit`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getGeneratedImagesRemainingLimit: async () => {
            const endpoint = `${url}/v4/ai/generatedImages/remainingLimit`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getPromptsRemainingLimit: async () => {
            const endpoint = `${url}/v4/ai/prompts/remainingLimit`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getGeneratedDocument: async (documentId) => {
            const endpoint = `${url}/v4/ai/documents/${documentId}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getGeneratedArtifacts: async (query) => {
            const endpoint = `${url}/v4/ai/generatedArtifacts`;
            const result = await httpClient.get(endpoint, { query });
            return result.data;
        },
        updateGeneratedDocument: async (documentId, payload) => {
            const endpoint = `${url}/v4/ai/documents/${documentId}`;
            await httpClient.put(endpoint, { payload });
            return;
        },
        createPublicDocumentLink: async (documentId) => {
            const endpoint = `${url}/v4/ai/documents/${documentId}/publicLink`;
            const result = await httpClient.post(endpoint);
            return result.data;
        },
        getPublicDocument: async (accessToken) => {
            const endpoint = `${url}/v4/ai/documents/public/${accessToken}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        uploadImage: async (formData, abortSignal) => {
            const endpoint = `${url}/v4/ai/images`;
            const result = await httpClient.post(endpoint, {
                payload: formData,
                abortSignal,
            });
            return result.data;
        },
        getGeneratedPodcast: async (podcastId, query) => {
            const endpoint = `${url}/v4/ai/generatedPodcasts/${podcastId}`;
            const result = await httpClient.get(endpoint, { query });
            return result.data;
        },
        updateGeneratedPodcast: async (podcastId, payload) => {
            const endpoint = `${url}/v4/ai/generatedPodcasts/${podcastId}`;
            await httpClient.put(endpoint, { payload });
            return;
        },
        stopConversationGeneration: async (conversationId, podcastId) => {
            const endpoint = `${url}/v4/ai/conversations/${conversationId}/stopGeneration`;
            await httpClient.post(endpoint, podcastId ? { payload: { podcastId } } : undefined);
            return;
        },
    };
};
exports.default = ai;
